// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/styles/fonts/SFProDisplay-Semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/styles/fonts/SFProDisplay-Semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/styles/fonts/SFProDisplay-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/styles/fonts/SFProDisplay-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Указываем box sizing */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* Убираем внутренние отступы */
ul[class],
ol[class] {
  padding: 0;
}

/* Убираем внешние отступы */
body,
h1,
h2,
h3,
h4,
p,
ul[class],
ol[class],
li,
figure,
figcaption,
blockquote,
dl,
dd {
  margin: 0;
}

/* Выставляем основные настройки по-умолчанию для body */
body {
  min-height: 100vh;
  scroll-behavior: smooth;
  text-rendering: optimizeSpeed;
  line-height: 1.5;
}

/* Удаляем стандартную стилизацию для всех ul и il, у которых есть атрибут class*/
ul[class],
ol[class] {
  list-style: none;
}

/* Элементы a, у которых нет класса, сбрасываем до дефолтных стилей */
a:not([class]) {
  text-decoration-skip-ink: auto;
}

/* Упрощаем работу с изображениями */
img {
  max-width: 100%;
  max-height: 100%;
  display: block;
  object-fit: contain;
}

/* Указываем понятную периодичность в потоке данных у article*/
article > * + * {
  margin-top: 1em;
}

/* Наследуем шрифты для инпутов и кнопок */
input,
button,
textarea,
select {
  font: inherit;
}

/* Удаляем все анимации и переходы для людей, которые предпочитай их не использовать */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
nav {
  margin: 0;
}

@font-face {
  font-family: "SF Pro Display";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: local("SF Pro Display Semibold"), local("SFProDisplay-Semibold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 600;
  font-style: normal;
}
:root {
  --appSidebarWidth: 400px;
  xPathesWrapperWidth: 400px;
}

.PageHeader_site-form-item-icon__hLUWd {
  color: #00A899;
}

.PageHeader_ant-tabs-content__YKSwP, .PageHeader_ant-tabs-tabpane__vvmc2 {
  height: 100% !important;
}

.PageHeader_ant-col__6B6\\+l.PageHeader_ant-form-item-control__p\\+GTk.PageHeader_css-dev-only-do-not-override-14wewjn__2pV6r label {
  display: inline !important;
}

.PageHeader_ant-form-item-control-input-content__pnGsw {
  display: flex;
  align-items: center !important;
  gap: 8px;
}

.PageHeader_site-tree-search-value__ROQZr {
  background: #d3fd1a;
}

.PageHeader_ant-tree__fda7A .PageHeader_ant-tree-treenode__myjFM {
  align-items: center !important;
}

textarea {
  overflow-y: scroll !important;
}

textarea::-webkit-scrollbar {
  width: 4px !important;
}

textarea::-webkit-scrollbar-thumb {
  background-color: #04867a !important;
  border-radius: 50px !important;
}

textarea::-webkit-scrollbar-track {
  background: #e2e4e7 !important;
}

.PageHeader_ant-tree-switcher__E633U.PageHeader_ant-tree-switcher_close__XkmBE,
.PageHeader_ant-tree-switcher__E633U.PageHeader_ant-tree-switcher_open__0gyWD {
  line-height: 46px !important;
}

div[class*=TableAllProjects] .PageHeader_ant-table-wrapper__dpSrU {
  padding: 24px !important;
  background: #fff !important;
}

.PageHeader_app-sidebar__0iqNM {
  width: 50%;
}

.PageHeader_app-sidebar__0iqNM .PageHeader_app-sidebar-content__7zFtN {
  width: 100%;
}

#PageHeader_CDARedactorWrapper__Opf12 {
  width: 100%;
  max-width: 100%;
}

.PageHeader_ant-tree-treenode__myjFM {
  min-width: 400px !important;
  max-width: 600px !important;
}

.PageHeader_fullScreen__Wg5fG {
  position: fixed !important;
  width: 100vw !important;
  height: 100vh !important;
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  z-index: 9 !important;
  background: #F0F2F5 !important;
}
.PageHeader_fullScreen__Wg5fG .PageHeader_app-container__ZA\\+Tp {
  min-height: 90vh;
  padding: 1em 1em;
  display: flex;
  flex-direction: row;
  height: 90vh;
}
.PageHeader_fullScreen__Wg5fG .PageHeader_app-sidebar__0iqNM {
  flex-grow: 0;
  flex-shrink: 0;
  min-width: 400px;
  max-width: calc(100vw - var(--appSidebarWidth)) !important;
  display: flex;
  flex-direction: row;
  z-index: 2;
}
.PageHeader_fullScreen__Wg5fG .PageHeader_app-frame__jDdVk {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 90vh;
  max-height: 90vh;
  width: calc(100vw - var(--xPathesWrapperWidth) - 200px) !important;
  min-width: 400px;
  border-radius: 0 10px 10px 0;
  z-index: 1;
}
.PageHeader_fullScreen__Wg5fG .PageHeader_app-sidebar__0iqNM .PageHeader_app-sidebar-content__7zFtN {
  flex: 1 1;
}
.PageHeader_fullScreen__Wg5fG .PageHeader_app-sidebar-resizer__LWi18 {
  position: relative;
  height: 84vh;
  width: 3px;
  top: 4vh;
  border-radius: 10px;
  background: rgba(193, 195, 197, 0.7058823529);
  flex-grow: 0;
  flex-shrink: 0;
  justify-self: flex-end;
  cursor: col-resize;
  resize: horizontal;
}
.PageHeader_fullScreen__Wg5fG .PageHeader_ant-tree-treenode__myjFM.PageHeader_ant-tree-treenode-switcher-open__v2NhB.PageHeader_ant-tree-treenode-draggable__dPvYM {
  width: 100% !important;
  max-width: 100% !important;
  position: relative;
}
.PageHeader_fullScreen__Wg5fG .PageHeader_app-sidebar__0iqNM .PageHeader_app-sidebar-resizer__LWi18:hover {
  width: 4px;
  background: grey;
}
.PageHeader_fullScreen__Wg5fG #PageHeader_CDAInitHeight__QzKOH {
  width: 100vw !important;
  height: 92vh !important;
  transition: width 0.5s !important;
}
.PageHeader_fullScreen__Wg5fG #PageHeader_CDA_content__Tq28j {
  width: 100% !important;
  height: 92vh !important;
  padding: 0 !important;
}
.PageHeader_fullScreen__Wg5fG .PageHeader_footer__b-0p\\+ > div {
  height: 8vh !important;
}
.PageHeader_fullScreen__Wg5fG [class^=VisualizationXPathes] {
  height: 69vh !important;
}
.PageHeader_fullScreen__Wg5fG #PageHeader_xPathesWrapper__7q\\+a7,
.PageHeader_fullScreen__Wg5fG #PageHeader_CDARedactorWrapper__Opf12 {
  max-width: 100%;
}
.PageHeader_fullScreen__Wg5fG #PageHeader_CDARedactor__O7W\\+2 {
  height: 100vh !important;
  transition: height 1s !important;
}
.PageHeader_fullScreen__Wg5fG #PageHeader_StructureXPathes__Uj2e0 {
  height: auto !important;
  transition: height 1s !important;
}
.PageHeader_fullScreen__Wg5fG #PageHeader_CDARedactor_tabContent__w1y8m,
.PageHeader_fullScreen__Wg5fG #PageHeader_StructureXPathes_content__unzLM {
  height: 76vh !important;
  transition: height 1s !important;
}

.PageHeader_ant-tree-treenode__myjFM {
  width: 100% !important;
}

.PageHeader_ant-tree-node-content-wrapper__d7WzL {
  width: 100% !important;
}

.PageHeader_ant-tree-checkbox__e7opq {
  align-self: center !important;
  margin-top: 0 !important;
}

.PageHeader_ant-tree-checkbox__e7opq + span {
  padding: 0 !important;
}

.PageHeader_ant-tree-treenode__myjFM.PageHeader_ant-tree-treenode-switcher-close__j1P-C.PageHeader_ant-tree-treenode-draggable__dPvYM {
  width: 100% !important;
  max-width: 100% !important;
}

.PageHeader_ant-tree-treenode__myjFM.PageHeader_ant-tree-treenode-switcher-open__v2NhB.PageHeader_ant-tree-treenode-draggable__dPvYM {
  width: 100% !important;
  max-width: 100% !important;
}

.PageHeader_ant-tabs-nav__jjOtd {
  height: 4vh !important;
}

.PageHeader_ant-tabs-tab-remove__6gMsV {
  padding: 0 !important;
}

@font-face {
  font-family: "SF Pro Display";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: local("SF Pro Display Semibold"), local("SFProDisplay-Semibold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "SF Pro Display";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: local("SF Pro Display Semibold"), local("SFProDisplay-Semibold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 600;
  font-style: normal;
}
.PageHeader_PageHeader__cqx0V {
  height: 8vh;
  position: relative;
  background: white;
  margin: 0 -24px 24px;
  padding: 0 24px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.PageHeader_PageHeader__cqx0V .PageHeader_links__by5Ru {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.PageHeader_PageHeader__cqx0V .PageHeader_links__by5Ru .PageHeader_showMenuBtn__WXa71 {
  position: absolute;
  width: 40px;
  height: 40px;
  left: 8px;
  top: 8px;
}
.PageHeader_PageHeader__cqx0V .PageHeader_links__by5Ru .PageHeader_titleWrapper__DrBqP {
  display: flex;
  gap: 16px;
}
.PageHeader_PageHeader__cqx0V .PageHeader_links__by5Ru .PageHeader_titleWrapper__DrBqP .PageHeader_title__7Iv1p {
  max-width: 24em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media (min-width: 320px) {
  .PageHeader_PageHeader__cqx0V .PageHeader_links__by5Ru .PageHeader_titleWrapper__DrBqP .PageHeader_title__7Iv1p {
    font: 600 16px/22px "SF Pro Display", sans-serif;
  }
}
@media (min-width: 768px) {
  .PageHeader_PageHeader__cqx0V .PageHeader_links__by5Ru .PageHeader_titleWrapper__DrBqP .PageHeader_title__7Iv1p {
    font: 600 18px/24px "SF Pro Display", sans-serif;
  }
}
@media (min-width: 1152px) {
  .PageHeader_PageHeader__cqx0V .PageHeader_links__by5Ru .PageHeader_titleWrapper__DrBqP .PageHeader_title__7Iv1p {
    font: 600 20px/28px "SF Pro Display", sans-serif;
  }
}
.PageHeader_PageHeader__cqx0V .PageHeader_btnsWrapper__yMYID .PageHeader_createBtn__vvJHf {
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/components/PageHeader/PageHeader.module.scss","webpack://./src/components/assets/styles/reset/reset.scss","webpack://./src/components/assets/styles/fonts/fonts.css","webpack://./src/components/assets/styles/base/base.scss","webpack://./src/components/assets/styles/mixins/mixins.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,yBAAA;AACA;;;EAGI,sBAAA;ADEJ;;ACCA,+BAAA;AACA;;EAEI,UAAA;ADEJ;;ACCA,4BAAA;AACA;;;;;;;;;;;;;;EAcI,SAAA;ADEJ;;ACCA,wDAAA;AACA;EACI,iBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gBAAA;ADEJ;;ACCA,iFAAA;AACA;;EAEI,gBAAA;ADEJ;;ACCA,qEAAA;AACA;EACI,8BAAA;ADEJ;;ACCA,oCAAA;AACA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;ADEJ;;ACCA,8DAAA;AACA;EACI,eAAA;ADEJ;;ACCA,0CAAA;AACA;;;;EAII,aAAA;ADEJ;;ACCA,sFAAA;AACA;EACI;IACI,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;EDEN;AACF;ACAA;EACI,SAAA;ADEJ;;AEnFA;EACI,6BAAA;EACA,4CAAA;EACA,uTAAA;EAKA,gBAAA;EACA,kBAAA;AFkFJ;AGzFA;EACE,wBAAA;EACA,0BAAA;AH2FF;;AG1EA;EACE,cAfW;AH4Fb;;AG1EA;EACE,uBAAA;AH6EF;;AGzEE;EACE,0BAAA;AH4EJ;;AGxEA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AH2EF;;AGvEA;EACE,mBAAA;AH0EF;;AGvEA;EACE,8BAAA;AH0EF;;AGvEA;EACE,6BAAA;AH0EF;;AGvEA;EACE,qBAAA;AH0EF;;AGvEA;EACE,oCAAA;EACA,8BAAA;AH0EF;;AGvEA;EACE,8BAAA;AH0EF;;AGvEA;;EAEE,4BAAA;AH0EF;;AGrEE;EACE,wBAAA;EACA,2BAAA;AHwEJ;;AGpEA;EACE,UAAA;AHuEF;;AGpEA;EACE,WAAA;AHuEF;;AGpEA;EACE,WAAA;EACA,eAAA;AHuEF;;AGpEA;EACE,2BAAA;EACA,2BAAA;AHuEF;;AGpEA;EACE,0BAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,8BAAA;AHuEF;AGrEE;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AHuEJ;AGpEE;EACE,YAAA;EACA,cAAA;EACA,gBAAA;EACA,0DAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AHsEJ;AGnEE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,kEAAA;EACA,gBAAA;EACA,4BAAA;EACA,UAAA;AHqEJ;AGlEE;EACE,SAAA;AHoEJ;AGjEE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,mBAAA;EACA,6CAAA;EAEA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AHkEJ;AGhEE;EAEE,sBAAA;EACA,0BAAA;EACA,kBAAA;AHiEJ;AG9DE;EACE,UAAA;EACA,gBAAA;AHgEJ;AG7DE;EACE,uBAAA;EACA,uBAAA;EACA,iCAAA;AH+DJ;AG7DE;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;AH+DJ;AG5DE;EACE,sBAAA;AH8DJ;AG5DE;EACE,uBAAA;AH8DJ;AG5DE;;EAEE,eAAA;AH8DJ;AG3DE;EACE,wBAAA;EACA,gCAAA;AH6DJ;AG1DE;EACE,uBAAA;EACA,gCAAA;AH4DJ;AGzDE;;EAEE,uBAAA;EACA,gCAAA;AH2DJ;;AGvDA;EACE,sBAAA;AH0DF;;AGvDA;EACE,sBAAA;AH0DF;;AGvDA;EACE,6BAAA;EACA,wBAAA;AH0DF;;AGvDA;EACE,qBAAA;AH0DF;;AGxDA;EACE,sBAAA;EACA,0BAAA;AH2DF;;AGzDA;EACE,sBAAA;EACA,0BAAA;AH4DF;;AGzDA;EACE,sBAAA;AH4DF;;AGzDA;EACE,qBAAA;AH4DF;;AE1SA;EACI,6BAAA;EACA,4CAAA;EACA,uTAAA;EAKA,gBAAA;EACA,kBAAA;AFySJ;AElTA;EACI,6BAAA;EACA,4CAAA;EACA,uTAAA;EAKA,gBAAA;EACA,kBAAA;AFgTJ;AAvTA;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;AAyTF;AAvTE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAyTJ;AAvTI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;AAyTN;AAtTI;EACE,aAAA;EACA,SAAA;AAwTN;AAvTM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAyTR;AIlVI;EJqBE;IIdE,gDAAA;EJ+UN;AACF;AIvVI;EJqBE;IIXE,gDAAA;EJiVN;AACF;AI5VI;EJqBE;IIRE,gDAAA;EJmVN;AACF;AAjUI;EACE,iBAAA;AAmUN","sourcesContent":["@import \"src/components/assets/styles/index\";\n\n.PageHeader {\n  height: 8vh;\n  position: relative;\n  background: white;\n  margin: 0 -24px 24px;\n  padding: 0 24px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n\n  .links {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    .showMenuBtn {\n      position: absolute;\n      width: 40px;\n      height: 40px;\n      left: 8px;\n      top: 8px;\n    }\n\n    .titleWrapper {\n      display: flex;\n      gap: 16px;\n      .title {\n        max-width: 24em;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        @include pageHeaderTitle;\n      }\n    }\n  }\n\n  .btnsWrapper {\n    .createBtn {\n      margin-right: 8px;\n    }\n\n    .applicationBtn {\n\n    }\n  }\n}\n","/* Указываем box sizing */\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n\n/* Убираем внутренние отступы */\nul[class],\nol[class] {\n    padding: 0;\n}\n\n/* Убираем внешние отступы */\nbody,\nh1,\nh2,\nh3,\nh4,\np,\nul[class],\nol[class],\nli,\nfigure,\nfigcaption,\nblockquote,\ndl,\ndd {\n    margin: 0;\n}\n\n/* Выставляем основные настройки по-умолчанию для body */\nbody {\n    min-height: 100vh;\n    scroll-behavior: smooth;\n    text-rendering: optimizeSpeed;\n    line-height: 1.5;\n}\n\n/* Удаляем стандартную стилизацию для всех ul и il, у которых есть атрибут class*/\nul[class],\nol[class] {\n    list-style: none;\n}\n\n/* Элементы a, у которых нет класса, сбрасываем до дефолтных стилей */\na:not([class]) {\n    text-decoration-skip-ink: auto;\n}\n\n/* Упрощаем работу с изображениями */\nimg {\n    max-width: 100%;\n    max-height: 100%;\n    display: block;\n    object-fit: contain;\n}\n\n/* Указываем понятную периодичность в потоке данных у article*/\narticle > * + * {\n    margin-top: 1em;\n}\n\n/* Наследуем шрифты для инпутов и кнопок */\ninput,\nbutton,\ntextarea,\nselect {\n    font: inherit;\n}\n\n/* Удаляем все анимации и переходы для людей, которые предпочитай их не использовать */\n@media (prefers-reduced-motion: reduce) {\n    * {\n        animation-duration: 0.01ms !important;\n        animation-iteration-count: 1 !important;\n        transition-duration: 0.01ms !important;\n        scroll-behavior: auto !important;\n    }\n}\nnav {\n    margin: 0;\n}","@font-face {\n    font-family: 'SF Pro Display';\n    src: url('SFProDisplay-Semibold.eot');\n    src: local('SF Pro Display Semibold'), local('SFProDisplay-Semibold'),\n        url('SFProDisplay-Semibold.eot?#iefix') format('embedded-opentype'),\n        url('SFProDisplay-Semibold.woff2') format('woff2'),\n        url('SFProDisplay-Semibold.woff') format('woff'),\n        url('SFProDisplay-Semibold.ttf') format('truetype');\n    font-weight: 600;\n    font-style: normal;\n}\n","@import \"../mixins/mixins\";\n\n:root {\n  --appSidebarWidth: 400px;\n  xPathesWrapperWidth: 400px;\n}\n\n$primeColor: #00A899;\n$backgroundColor: #04867a;\n\nbody {\n  //font-family: Roboto;\n  //font-size: 14px;\n  //font-style: normal;\n  //font-weight: 500;\n  //line-height: 22px;\n  //font-family: \"SF Pro Display\", serif;\n  //font-weight: 500;\n  //min-height: 100%;\n}\n\n.site-form-item-icon {\n  color: $primeColor;\n}\n\n.ant-tabs-content, .ant-tabs-tabpane {\n  height: 100% !important;\n}\n\n.ant-col.ant-form-item-control.css-dev-only-do-not-override-14wewjn {\n  label {\n    display: inline !important;\n  }\n}\n\n.ant-form-item-control-input-content {\n  display: flex;\n  align-items: center !important;\n  gap: 8px;\n}\n\n\n.site-tree-search-value {\n  background: #d3fd1a;\n}\n\n.ant-tree .ant-tree-treenode {\n  align-items: center !important;\n}\n\ntextarea {\n  overflow-y: scroll !important;\n}\n\ntextarea::-webkit-scrollbar {\n  width: 4px !important;\n}\n\ntextarea::-webkit-scrollbar-thumb {\n  background-color: $backgroundColor !important;\n  border-radius: 50px !important;\n}\n\ntextarea::-webkit-scrollbar-track {\n  background: #e2e4e7 !important;\n}\n\n.ant-tree-switcher.ant-tree-switcher_close,\n.ant-tree-switcher.ant-tree-switcher_open {\n  line-height: 46px !important;\n}\n\ndiv[class*=\"TableAllProjects\"] {\n  //.ant-table-wrapper.css-dev-only-do-not-override-1x83488 {\n  .ant-table-wrapper {\n    padding: 24px !important;\n    background: #fff !important;\n  }\n}\n\n.app-sidebar {\n  width: 50%;\n}\n\n.app-sidebar .app-sidebar-content {\n  width: 100%;\n}\n\n#CDARedactorWrapper {\n  width: 100%;\n  max-width: 100%;\n}\n\n.ant-tree-treenode {\n  min-width: 400px !important;\n  max-width: 600px !important;\n}\n\n.fullScreen {\n  position: fixed !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  left: 0 !important;\n  right: 0 !important;\n  top: 0 !important;\n  bottom: 0 !important;\n  z-index: 9 !important;\n  background: #F0F2F5 !important;\n\n  .app-container {\n    min-height: 90vh;\n    padding: 1em 1em;\n    display: flex;\n    flex-direction: row;\n    height: 90vh;\n  }\n\n  .app-sidebar {\n    flex-grow: 0;\n    flex-shrink: 0;\n    min-width: 400px;\n    max-width: calc(100vw - var(--appSidebarWidth))!important;\n    display: flex;\n    flex-direction: row;\n    z-index: 2;\n  }\n\n  .app-frame {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    height: 90vh;\n    max-height: 90vh;\n    width: calc(100vw - var(--xPathesWrapperWidth) - 200px)!important;\n    min-width: 400px;\n    border-radius: 0 10px 10px 0;\n    z-index: 1;\n  }\n\n  .app-sidebar .app-sidebar-content {\n    flex: 1;\n  }\n\n  .app-sidebar-resizer {\n    position: relative;\n    height: 84vh;\n    width: 3px;\n    top: 4vh;\n    border-radius: 10px;\n    background: #c1c3c5b4;\n\n    flex-grow: 0;\n    flex-shrink: 0;\n    justify-self: flex-end;\n    cursor: col-resize;\n    resize: horizontal;\n  }\n  .ant-tree-treenode.ant-tree-treenode-switcher-open.ant-tree-treenode-draggable{\n    //width: calc(100vw - var(--xPathesWrapperWidth))!important;\n    width: 100%!important;\n    max-width: 100%!important;\n    position: relative;\n  }\n\n  .app-sidebar .app-sidebar-resizer:hover {\n    width: 4px;\n    background: grey;\n  }\n\n  #CDAInitHeight {\n    width: 100vw !important;\n    height: 92vh !important;\n    transition: width 0.5s !important;\n  }\n  #CDA_content {\n    width: 100% !important;\n    height: 92vh !important;\n    padding: 0!important;\n  }\n\n  .footer > div {\n    height: 8vh!important;\n  }\n  [class^=VisualizationXPathes] {\n    height: 69vh!important;\n  }\n  #xPathesWrapper,\n  #CDARedactorWrapper {\n    max-width: 100%;\n  }\n\n  #CDARedactor {\n    height: 100vh !important;\n    transition: height 1s !important;\n  }\n\n  #StructureXPathes {\n    height: auto !important;\n    transition: height 1s !important;\n  }\n\n  #CDARedactor_tabContent,\n  #StructureXPathes_content {\n    height: 76vh !important;\n    transition: height 1s !important;\n  }\n}\n\n.ant-tree-treenode {\n  width: 100% !important;\n}\n\n.ant-tree-node-content-wrapper {\n  width: 100% !important;\n}\n\n.ant-tree-checkbox {\n  align-self: center !important;\n  margin-top: 0 !important;\n}\n\n.ant-tree-checkbox + span {\n  padding: 0 !important;\n}\n.ant-tree-treenode.ant-tree-treenode-switcher-close.ant-tree-treenode-draggable {\n  width: 100%!important;\n  max-width: 100%!important;\n}\n.ant-tree-treenode.ant-tree-treenode-switcher-open.ant-tree-treenode-draggable {\n  width: 100%!important;\n  max-width: 100%!important;\n}\n\n.ant-tabs-nav {\n  height: 4vh!important;\n}\n\n.ant-tabs-tab-remove {\n  padding: 0!important;\n}","@import \"../fonts/fonts\";\n\n$mobile: 320px;\n$tablet: 768px;\n$desktop: 1152px;\n\n@mixin media($size) {\n    @media (min-width: $size) {\n        @content;\n    }\n}\n\n@mixin pageHeaderTitle {\n    @include media($mobile) {\n        font: 600 16px/22px 'SF Pro Display', sans-serif;\n    }\n    @include media($tablet) {\n        font: 600 18px/24px 'SF Pro Display', sans-serif;\n    }\n    @include media($desktop) {\n        font: 600 20px/28px 'SF Pro Display', sans-serif;\n    }\n}\n@mixin widgetTable {\n    @include media($mobile) {\n        font: 600 12px/20px 'SF Pro Display', sans-serif;\n    }\n    @include media($tablet) {\n        font: 600 14px/22px 'SF Pro Display', sans-serif;\n    }\n    @include media($desktop) {\n        font: 600 16px/24px 'SF Pro Display', sans-serif;\n    }\n}\n@mixin widgetTitle {\n    @include media($mobile) {\n        font: 600 12px/20px 'SF Pro Display', sans-serif;\n    }\n    @include media($tablet) {\n        font: 600 14px/22px 'SF Pro Display', sans-serif;\n    }\n    @include media($desktop) {\n        font: 600 16px/24px 'SF Pro Display', sans-serif;\n    }\n}\n@mixin widgetValue {\n    @include media($mobile) {\n        font: 600 20px/30px 'SF Pro Display', sans-serif;\n    }\n    @include media($tablet) {\n        font: 600 22px/32px 'SF Pro Display', sans-serif;\n    }\n    @include media($desktop) {\n        font: 600 24px/34px 'SF Pro Display', sans-serif;\n    }\n}\n@mixin changeLang {\n    @include media($mobile) {\n        font: 600 12px/20px 'SF Pro Display', sans-serif;\n    }\n    @include media($tablet) {\n        font: 600 14px/22px 'SF Pro Display', sans-serif;\n    }\n    @include media($desktop) {\n        font: 400 16px/24px 'SF Pro Display' sans-serif;\n    }\n}\n@mixin changePasswordTitle {\n    @include media($mobile) {\n        font: 400 50px/60px 'SF Pro Display', sans-serif;\n    }\n    @include media($tablet) {\n        font: 400 54px/62px 'SF Pro Display', sans-serif;\n    }\n    @include media($desktop) {\n        font: 400 56px/64px 'SF Pro Display', sans-serif;\n    }\n}\n@mixin changePasswordCardTitle {\n    @include media($mobile) {\n        font: 600 16px/20px 'SF Pro Display', sans-serif;\n    }\n    @include media($tablet) {\n        font: 600 18px/22px 'SF Pro Display', sans-serif;\n    }\n    @include media($desktop) {\n        font: 600 20px/24px 'SF Pro Display', sans-serif;\n    }\n}\n@mixin birthdayTitle {\n    @include media($mobile) {\n        font: 600 10px/18px 'SF Pro Display', sans-serif;\n    }\n    @include media($tablet) {\n        font: 600 12px/20px 'SF Pro Display', sans-serif;\n    }\n    @include media($desktop) {\n        font: 400 14px/22px 'SF Pro Display', sans-serif;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"site-form-item-icon": `PageHeader_site-form-item-icon__hLUWd`,
	"ant-tabs-content": `PageHeader_ant-tabs-content__YKSwP`,
	"ant-tabs-tabpane": `PageHeader_ant-tabs-tabpane__vvmc2`,
	"ant-col": `PageHeader_ant-col__6B6+l`,
	"ant-form-item-control": `PageHeader_ant-form-item-control__p+GTk`,
	"css-dev-only-do-not-override-14wewjn": `PageHeader_css-dev-only-do-not-override-14wewjn__2pV6r`,
	"ant-form-item-control-input-content": `PageHeader_ant-form-item-control-input-content__pnGsw`,
	"site-tree-search-value": `PageHeader_site-tree-search-value__ROQZr`,
	"ant-tree": `PageHeader_ant-tree__fda7A`,
	"ant-tree-treenode": `PageHeader_ant-tree-treenode__myjFM`,
	"ant-tree-switcher": `PageHeader_ant-tree-switcher__E633U`,
	"ant-tree-switcher_close": `PageHeader_ant-tree-switcher_close__XkmBE`,
	"ant-tree-switcher_open": `PageHeader_ant-tree-switcher_open__0gyWD`,
	"ant-table-wrapper": `PageHeader_ant-table-wrapper__dpSrU`,
	"app-sidebar": `PageHeader_app-sidebar__0iqNM`,
	"app-sidebar-content": `PageHeader_app-sidebar-content__7zFtN`,
	"CDARedactorWrapper": `PageHeader_CDARedactorWrapper__Opf12`,
	"fullScreen": `PageHeader_fullScreen__Wg5fG`,
	"app-container": `PageHeader_app-container__ZA+Tp`,
	"app-frame": `PageHeader_app-frame__jDdVk`,
	"app-sidebar-resizer": `PageHeader_app-sidebar-resizer__LWi18`,
	"ant-tree-treenode-switcher-open": `PageHeader_ant-tree-treenode-switcher-open__v2NhB`,
	"ant-tree-treenode-draggable": `PageHeader_ant-tree-treenode-draggable__dPvYM`,
	"CDAInitHeight": `PageHeader_CDAInitHeight__QzKOH`,
	"CDA_content": `PageHeader_CDA_content__Tq28j`,
	"footer": `PageHeader_footer__b-0p+`,
	"xPathesWrapper": `PageHeader_xPathesWrapper__7q+a7`,
	"CDARedactor": `PageHeader_CDARedactor__O7W+2`,
	"StructureXPathes": `PageHeader_StructureXPathes__Uj2e0`,
	"CDARedactor_tabContent": `PageHeader_CDARedactor_tabContent__w1y8m`,
	"StructureXPathes_content": `PageHeader_StructureXPathes_content__unzLM`,
	"ant-tree-node-content-wrapper": `PageHeader_ant-tree-node-content-wrapper__d7WzL`,
	"ant-tree-checkbox": `PageHeader_ant-tree-checkbox__e7opq`,
	"ant-tree-treenode-switcher-close": `PageHeader_ant-tree-treenode-switcher-close__j1P-C`,
	"ant-tabs-nav": `PageHeader_ant-tabs-nav__jjOtd`,
	"ant-tabs-tab-remove": `PageHeader_ant-tabs-tab-remove__6gMsV`,
	"PageHeader": `PageHeader_PageHeader__cqx0V`,
	"links": `PageHeader_links__by5Ru`,
	"showMenuBtn": `PageHeader_showMenuBtn__WXa71`,
	"titleWrapper": `PageHeader_titleWrapper__DrBqP`,
	"title": `PageHeader_title__7Iv1p`,
	"btnsWrapper": `PageHeader_btnsWrapper__yMYID`,
	"createBtn": `PageHeader_createBtn__vvJHf`
};
export default ___CSS_LOADER_EXPORT___;
